import * as yup from "yup";

export type LinkEvidenceFormValues = {
    documentUrl: string;
    validFromDate: Date | null;
    validToDate: Date | null;
};

export const linkEvidenceFormValidationSchema = yup.object({
    documentUrl: yup.string().required("Please enter a valid URL"),
    validFromDate: yup
        .date()
        .required("Please enter a valid date")
        .typeError("Please enter a valid date"),
    validToDate: yup
        .date()
        .min(yup.ref("validFromDate"), "Must be equal/after valid from date")
        .required("Please enter a valid date")
        .typeError("Please enter a valid date"),
});

export const defaultLinkEvidenceFormValues: LinkEvidenceFormValues = {
    documentUrl: "",
    validFromDate: null,
    validToDate: null,
};
